import { AxiosError, isAxiosError } from 'axios';

import { APIErrorResponse } from '@percent/hosted-validation-form/api/types/types';

// The response interceptor wraps 400/401/500 into an ErrorBase carrying the original
// AxiosError as `cause`, and rethrows everything else (e.g. 422, 429) untouched.
export const toAxiosError = (error: unknown): AxiosError<APIErrorResponse> | undefined => {
  if (isAxiosError<APIErrorResponse>(error)) {
    return error;
  }

  if (error instanceof Error && isAxiosError<APIErrorResponse>(error.cause)) {
    return error.cause;
  }

  return undefined;
};
